"use client";

import { useRef, useState } from "react";
import { track } from "@/lib/analytics/tracker";
import type { ListingAddressDialogIntent } from "./listing-buy-state";

export function useTrackedAddressDialog(hasAddress: boolean) {
  const [addressDialog, setAddressDialog] = useState<ListingAddressDialogIntent | null>(null);
  const opened = useRef<{ intent: ListingAddressDialogIntent; at: number } | null>(null);
  const trackClose = () => {
    if (!opened.current) return;
    track("listing.address_dialog_closed", { intent: opened.current.intent, has_address: hasAddress, duration_ms: Date.now() - opened.current.at });
    opened.current = null;
  };
  return {
    addressDialog,
    openAddressDialog: (intent: ListingAddressDialogIntent) => {
      if (opened.current?.intent !== intent) {
        trackClose();
        opened.current = { intent, at: Date.now() };
        track("listing.address_dialog_opened", { intent, has_address: hasAddress });
      }
      setAddressDialog(intent);
    },
    closeAddressDialog: () => {
      trackClose();
      setAddressDialog(null);
    },
  };
}
